import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { ExperienceAreaService } from '../experience-area.service';
import { ExperienceAIAdvisorService } from './experience-ai-advisor.service';
import { ExperienceAIAdvisorTab1Part } from './tabs/tab-1/experience-ai-advisor-tab-1.part';
import { ExperienceAIAdvisorTab2Part } from './tabs/tab-2/experience-ai-advisor-tab-2.part';
import { ExperienceAIAdvisorViewsPart } from './views/ai-advisor-views.part';

@Component({
	selector: 'experience-ai-advisor-page',
	standalone: true,
	imports: [
		ExperienceAIAdvisorViewsPart,
		ExperienceAIAdvisorTab1Part,
		ExperienceAIAdvisorTab2Part,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		PageTabsWidget,
		TrimesterDroplistWidget,
		DroplistWidget,
		ToolbarWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './experience-ai-advisor.page.html',
})
export class ExperienceAIAdvisorPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;
	public areService = inject(ExperienceAreaService);

	constructor(public pageService: ExperienceAIAdvisorService) { }

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}
